<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
      <!-- <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" /> -->
    </div>
</template>

<script>
import personasStore from '@/store/gestion/personas/index.js'

export default {
  name: 'CellRendererActions',
  methods: {
    async editRecord () {
      this.$vs.loading('material') // Mostramos unha animación de 'cargando...'
      try {
        if (!personasStore.isRegistered) {
          this.$store.registerModule('personasStore', personasStore)
          personasStore.isRegistered = true
        }

        await this.$store.dispatch('personasStore/getPersona', this.params.data.id)
          .then((response) => {
            this.persona = response.data
            // this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
          })
          .catch(
            // this.$vs.loading.close()  // Pechamos a animación de 'cargando...'
          )
      } catch (error) {
        console.error(error)
      }
      const ruta = `/gestion/clientes/editar/${this.params.data.id}`
      this.$router.push(ruta).catch(() => {})
    }
  }
}
</script>
